import styled from 'styled-components'
import { useRouter } from 'next/router'
import { useEffect, useMemo, useState } from 'react'
import { userApi } from '@/common/services/api'
import { getCookie, setCookie } from 'cookies-next'
import { TOKEN_KEY, USER_LANG_KEY } from '@/common/constants/cookies'

import HeaderDropdown from './common/HeaderDropdown'

import { AVAILABLE_ARR_LANGS } from '@/common/constants/language'
import { useDispatch } from 'react-redux'
import { setLang } from '@/store/languageSlice'
import baseLogger from '@/common/services/BaseLogger'
import userLanguage from '@/common/services/userLanguage'
import Link from 'next/link'
import { userAmplitudeAnalytics } from '@/common/services/userAmplitudeAnalytics'
import { ANALYTIC_HEADER } from '@/common/constants/analytics'

const Button = styled.button`
  font-size: 0.875em;
  color: ${(props) =>
    props.active ? 'var(--yellow) !important' : 'var(--grey-light)'};
  background-color: transparent;
  display: block;
  cursor: ${(props) => (props.active ? 'default' : 'pointer')};

  &:hover {
    color: var(--grey);
  }

  &:active {
    color: var(--black);
  }
`

const HeaderLangs = ({ languagesLinks, ...props }) => {
  const dispatch = useDispatch()
  const router = useRouter()
  const { locale } = router
  const currentLanguage = useMemo(() => locale, [locale])
  const [currentHash, setCurrentHash] = useState('')

  const changeCurrentLanguage = async (e) => {
    const currentUrl = window.location.href
    localStorage.setItem('currentHash', currentHash)
    const queryParams = new URLSearchParams(router.query)
    const language = e.target.value
    const newUrl = new URL(currentUrl)
    newUrl.search = queryParams.toString()
    setCookie(USER_LANG_KEY, language)
    userLanguage.setLanguage(language)
    userAmplitudeAnalytics.trackEvent(
      `${ANALYTIC_HEADER}_language_choose_clicked`,
      {
        languageChosen: language,
      }
    )
    await dispatch(setLang(language))
    if (!getCookie(TOKEN_KEY)) return

    try {
      await userApi.changeUserLanguage({
        data: {
          language,
        },
      })
    } catch (e) {
      baseLogger.logger.error(e, 'failed set language')
    }
  }

  useEffect(() => {
    const handleHashChange = () => {
      setCurrentHash(window.location.hash)
    }

    window.addEventListener('hashchange', handleHashChange)

    return () => {
      window.removeEventListener('hashchange', handleHashChange)
    }
  }, [])

  const languagePath = (language) => {
    if (languagesLinks && Object.keys(languagesLinks).length) {
      const correctQuery = languagesLinks[language]
        ? languagesLinks[language].slug
        : router.query.id
      const currentPath = router.asPath
      return currentPath.replace(router.query.id, correctQuery)
    }
    return router.pathname === '/' ? currentHash : router.asPath
  }

  const onToggleDropdown = (isVisible) => {
    if (isVisible) {
      userAmplitudeAnalytics.trackEvent(`${ANALYTIC_HEADER}_language_clicked`, {
        language: locale,
      })
    }
  }

  return (
    <HeaderDropdown
      triggerText={currentLanguage.toUpperCase()}
      triggerClickCallback={onToggleDropdown}
      contentWidth="80"
      {...props}
    >
      {AVAILABLE_ARR_LANGS.map((el) =>
        currentLanguage === el ? (
          <Button
            key={`${el}-button`}
            active={currentLanguage === el}
            className="mb-3"
            value={el}
            onClick={changeCurrentLanguage}
          >
            {el.toUpperCase()}
          </Button>
        ) : (
          <Link
            key={`${el}-link`}
            href={languagePath(el)}
            locale={el}
            scroll={false}
          >
            <Button
              active={currentLanguage === el}
              className="mb-3"
              value={el}
              onClick={changeCurrentLanguage}
            >
              {el.toUpperCase()}
            </Button>
          </Link>
        )
      )}
    </HeaderDropdown>
  )
}

export default HeaderLangs
